import * as KendoButton from '@progress/kendo-react-buttons'
import { ExcelExport } from '@progress/kendo-react-excel-export';
import { Grid, GridColumn, GridToolbar } from '@progress/kendo-react-grid'
import toPairs from 'lodash/fp/toPairs'
import isEmpty from 'lodash/isEmpty'
import * as React from 'react'
import {connect} from 'react-redux'
import {Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row} from 'reactstrap'
import * as Redux from 'redux'
import * as App from '../../app'
import { FlashMessage } from '../../components/flash-message'
import * as Link from '../../components/link'
import {Loading} from '../../components/loading'
import * as RasaModal from '../../components/modal'
import * as RasaInput from '../../components/rasa-input'
import * as Sortable from '../../components/sortable'
import * as Request from '../../request'
import * as CommunityConfig from '../community-config'
import * as GridCell from '../grid-cell'
import * as Reference from '../reference'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Render from './render'
import './styles.css'
import * as Types from './types'
import * as Utils from './utils'

type AppProps = App.WrappedState

interface SubmitAddUserProps {
  communities?: CommunityConfig.Communities,
  submitModal: RasaModal.Submit<Types.ModalData>
}
interface RoleProps {
  roles: Types.Role[]
}

type AddUserModalProps =
  RasaModal.ComponentState<Types.ModalData> &
  RasaModal.DispatchState &
  SubmitAddUserProps &
  AppProps & RoleProps

export const AddUserModal =
  ({app, communities, modal, showModal, submitModal, updateModal, roles}: AddUserModalProps) =>
  <Modal className="modal-lg" isOpen={modal.isOpen} toggle={showModal}>
    <form className="k-form"
          onSubmit={Link.preventDefaultThen(() => submitModal(app.selectedCommunity, modal.data))}>
      <FlashMessage />
      <ModalHeader toggle={showModal}>{modal.modalTitle}</ModalHeader>
      <ModalBody>
        <Row>
          <Col>
            <RasaInput.RasaInput label=""
                                placeholder="Email"
                                value={modal.data.email}
                                disabled = {modal.data.icp_guid !== ''}
                                validation={RasaInput.validateEmail(modal.data.email)}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                updateModal({name: 'email', value: e.target.value})} />
          </Col>
            {!isEmpty(communities) &&
            <Col>
              <RasaInput.RasaSelectInput label=""
                value={modal.data.communityIdentifier}
                options={toPairs(communities).map(([c, _]) => ({key: c, description: c}))}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  updateModal({name: 'communityIdentifier', value: e.target.value})}/>
            </Col>
          }
        </Row>
        <Row>
          <Col>
            <h4>Select Roles</h4>
            <Grid data={Utils.getPersonRoles(modal.data.person_roles, roles)}>
              <GridColumn field="name" title="Name"/>
              <GridColumn cell={Render.PersonRoleActiveCell} field="is_active" title="Active" />
            </Grid>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        {modal.isSubmitting ? <Loading size={Loading.Sizes.SMALL} /> : <span/>}
        <Button color="primary"
          disabled={modal.isSubmitting || !Utils.addUserModalStateValid(modal.data)}
        >
          Save
        </Button>
        <Button onClick={showModal}>Cancel</Button>
      </ModalFooter>
    </form>
  </Modal>

export const AddUserModalConnect = connect(
  ({app}: AppProps) => ({app}),
  {
    showModal: Actions.showAddUserModal,
    submitModal: Actions.createOrUpdate,
    updateModal: Actions.updateAddUserModalField,
  },
)(AddUserModal)

interface HeaderProps {
  showAddUserModal: RasaModal.Toggle,
}
const Header = ({showAddUserModal}: HeaderProps ) =>
  <div>
    <FlashMessage />
    <Row className="margin-auto">
      <Col sm="12" md="10" className="text-left page-header--padding">
        <div className="page-header">
          <span className="title">Users</span>
          <Button
            className="secondary-button"
            onClick={showAddUserModal}
            title="Add User">
            Add
          </Button>
        </div>
      </Col>
    </Row>
  </div>

const HeaderConnect = connect(
  null,
  ({
    showAddUserModal: Actions.showAddUserModal,
  }),
)(Header)

interface DispatchProps {
  communities?: CommunityConfig.Communities,
  dispatch: Redux.Dispatch<Redux.Action>,
}
type UsersProps = Types.WrappedState & DispatchProps & Reference.WrappedState
export const Users = (props: UsersProps) => {
  return props.users.view.isLoading ?
      <Loading center size={Loading.Sizes.LARGE} />
    :
      <div>
        <Row>
          <Col>
            <HeaderConnect />
          </Col>
        </Row>
        <AddUserModalConnect modal={props.users.modal}
                             roles={props.referenceData.roles}
                             communities={props.communities}/>
        <div>
          <Row>
            <Col>
              <UserGridCopmonent {...props} />
            </Col>
          </Row>
        </div>
      </div>
}

class UserGridCopmonent extends React.PureComponent<UsersProps> {
  private xlsxExport: any = null
  constructor(props: UsersProps) {
    super(props)
  }
  public render() {
    return <div>
      <GridToolbar>
        <KendoButton.Button primary look="outline"
          disabled={this.props.users.data.length < 1}
          onClick={() => this.xlsxExport.save()}>
          Export xlsx
        </KendoButton.Button>
      </GridToolbar>
      <ExcelExport data={this.props.users.data}
        fileName="RasaUsers.xlsx"
        ref={(exporter) => {this.xlsxExport = exporter}}>
        <Grid data={Request.withDispatch(this.props.users.data, this.props.dispatch)}
                    sortable={{
                      allowUnsort: true,
                      mode: 'multiple',
                    }}
                    sort={this.props.users.view.sort}
                    onSortChange={(e) => this.props.dispatch({
                                          options: { value: e.sort },
                                          type: Sortable.sortTableConstant(Constants.FETCH_USERS),
                    })}>
                <GridColumn field="community_identifier" title="Identifier"/>
                <GridColumn field="username" title="Username"/>
                <GridColumn field="email" title="Email"/>
                <GridColumn field="first_name" title="FirstName"/>
                <GridColumn field="last_name" title="LastName"/>
                <GridColumn field="UserStatus" title="Status"/>
                <GridColumn field="UserCreateDate" title="Created"/>
                <GridColumn cell={GridCell.DateTimeCell} field="UserLastModifiedDate_datetime" title="Updated"/>
                <GridColumn cell={Render.ResetCell} title="Reset" sortable={false} />
                <GridColumn cell={Render.ActiveCell} field="is_active" title="Active" />
                <GridColumn cell={Render.EditCell} />
              </Grid>
      </ExcelExport>
    </div>
  }
}

type UsersState = Types.WrappedState & Reference.WrappedState
export const UsersConnected = connect(
  ({referenceData, users}: UsersState) =>
    ({
      referenceData,
      users,
    }),
  (dispatch: any) => ({dispatch}),
)(Users)

type AdminUsersState = Types.WrappedState & Reference.WrappedState & CommunityConfig.CommunitiesWrappedState
export const AdminUsersConnected = connect(
  ({communities, referenceData, users}: AdminUsersState) =>
    ({
      communities,
      referenceData,
      users,
    }),
  (dispatch: any) => ({dispatch}),
)(Users)



// WEBPACK FOOTER //
// ./src/pages/users/component.tsx